import { render } from "./ItemPackagesConditionForm.vue?vue&type=template&id=2b4cc699"
import script from "./ItemPackagesConditionForm.vue?vue&type=script&lang=js"
export * from "./ItemPackagesConditionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__